// src/components/legacyMobileDrawer/NotificationDrawerLink.jsx
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosConn from '../../axiosConn';
import { AuthContext } from '../../context/AuthContext';
import { SocketContext } from '../../context/socket';

const NotificationDrawerLink = ({ onClick }) => {
  const { player } = useContext(AuthContext);
  const { socket } = useContext(SocketContext);

  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnread = useCallback(async () => {
    try {
      const { data } = await axiosConn.get('notifications/my/unread-count', {
        headers: { Authorization: `Bearer ${player?.token}` },
      });
      setUnreadCount(Number(data?.data?.count || data?.count || 0));
    } catch {
      // best-effort; keep last known value
    }
  }, [player?.token]);

  // Initial + backup poll
  useEffect(() => {
    if (!player?.token) return;
    fetchUnread();
    const t = setInterval(fetchUnread, 60_000);
    return () => clearInterval(t);
  }, [player?.token, fetchUnread]);

  // Live updates from socket
  useEffect(() => {
    if (!socket || !socket.on) return;
    const onNew = () => setUnreadCount((c) => Math.min(999, c + 1));
    socket.on('notification:new', onNew);
    return () => socket.off && socket.off('notification:new', onNew);
  }, [socket]);

  return (
    <li>
      <Link
        className="drawer-link-btn"
        to="/notifications"
        onClick={onClick}
        aria-label={`Notifications (${unreadCount} unread)`}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          textDecoration: 'none',
        }}
      >
        <span
          className="drawer-link-label"
          style={{ display: 'inline-flex', alignItems: 'center' }}
        >
          🔔 Notifications
        </span>

        {unreadCount > 0 && (
          <span
            className="pulse-badge"
            aria-hidden
            style={{
              marginLeft: 8,
              minWidth: 26,
              height: 20,
              padding: '0 8px',
              borderRadius: 999,
              background: '#ef4444',
              color: '#fff',
              fontSize: 12,
              lineHeight: '20px',
              textAlign: 'center',
              fontWeight: 800,
              boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            }}
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </Link>
    </li>
  );
};

export default NotificationDrawerLink;
